/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import {elements} from '@ecosystem/newron-design-system';
import * as styles from '../pg-loading-info/LoadingInfo.module.scss';
import {usePageConfig} from '@utils/pageConfig/PagesConfigContext';

const { Icon } = elements;
const { Fractional } = Icon.icons;
const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <button data-testid="loading-info-link" className={styles.LoadingInfo__Link} onClick={onClick}>
      Dismiss
    </button>
  );
};

const LoadingInfo: React.FC = () => {
  const [isDismiss, setIsDismiss] = useState<boolean>(false);
  const [data, setData] = useState({
    isVisible: true,
    message: 'This mark means that some data is not available yet',
  });

  const pagesConfig = usePageConfig();
  const onClick = () => {
    setIsDismiss(true);
  };

  useEffect(() => {
    if (isDismiss) {
      setData({
        isVisible: false,
        message: '',
      });
      pagesConfig.setIsHidePGInfoWarning(true);
    }
  }, [isDismiss]);

  return data.isVisible ? (
    <>
      <br />
      <div className="flex">
        <div className="row-span-2">
          <Icon color="secondaryInteractive">
            <Fractional />
          </Icon>
        </div>
        <div>
          <div className="ml-2">{data.message}</div>

          <div className="ml-1">
            <CloseButton onClick={onClick} />
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export default LoadingInfo;
